import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'designer:backTo';

const BACK_TARGETS: Record<string, string> = {
  '/dashboard': 'Back to dashboard',
  '/mylibrary/games': 'Back to library'
};

export function useDesignerBack() {
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from;

  if (from && BACK_TARGETS[from]) {
    sessionStorage.setItem(STORAGE_KEY, from);
  }

  const to =
    (from && BACK_TARGETS[from] && from) ||
    sessionStorage.getItem(STORAGE_KEY) ||
    '/dashboard';

  return { to, label: BACK_TARGETS[to] ?? BACK_TARGETS['/dashboard'] };
}
